import { Box, styled } from '@mui/material';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { MobileDatePicker } from '@mui/x-date-pickers';
import { palette } from '../../theme/palette';

interface StyledDatePickerProps {
  isStyledForFormDatePicker?: boolean;
}

export const StyledDatePickerContainer = styled(DemoContainer)``;

export const DatePickerWrapper = styled(Box)`
  width: 100%;
`;

export const StyledDatePicker = styled(MobileDatePicker)<StyledDatePickerProps>(
  ({ isStyledForFormDatePicker }) => ({
    minWidth: '-webkit-fill-available',
    '& .css-4nc7oo-MuiTypography-root': {
      letterSpacing: '0.35px',
      lineHeight: '32px',
    },
    '& .MuiFormControl-root': {
      width: '100%',
    },
    '& .MuiInputBase-root': {
      borderRadius: '5px',
      border: `0.75px solid ${palette.custom.grey}`,
      backgroundColor: `${palette.primary.contrastText}`,
      height: '48px',
      flexShrink: 0,
      paddingTop: 0,
      width: '100%',
    },
    '.MuiInputBase-input': {
      padding: isStyledForFormDatePicker ? '0px' : '5px',
      textAlign: isStyledForFormDatePicker ? 'start' : 'center',
      fontSize: isStyledForFormDatePicker ? '14px' : 'initial',
      letterSpacing: '0.35px',
      lineHeight: '32px',
    },
    '.MuiInputBase-input::placeholder': {
      color: `${palette.custom.darkGrey}`,
      textAlign: 'center',
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: '400',
      lineHeight: isStyledForFormDatePicker ? '32px' : '22px',
      letterSpacing: '0.35px',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: '0',
    },
    '& .MuiInputAdornment-root': {
      paddingLeft: '0px',
      marginLeft: '-4px',
      color: `${palette.custom.black}`,
    },
    '& .MuiInputAdornment-root .MuiIconButton-root': {
      color: `${palette.custom.black}`,
    },
  }),
);
